const MENUS_TABLE_READY = "menus-table-ready"
const SEARCH_TEXT_STATE = "menus-table-search-text-state"
const ROWS_PER_PAGE_STATE = "menus-table-rows-per-page-state"
const PAGINATION_STATE = "menus-table-pagination-state"

const MENU_ID_FOR_ACTION = "menus-table-menu-id-for-action"

const ADD_EDIT_MENU_READY = "add-edit-menu-ready"


const PREVIOUS_MENU_FILTER_CITY = "previous-menu-filter-city-action"
const PREVIOUS_MENU_FILTER_SKU = "previous-menu-filter-sku-action"



const initialState = {
    isMenusTableReady: true,
    isAddEditMenuReady:true,
    menus: {},

    
    menuSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    previousFilterSku :false,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case MENUS_TABLE_READY:
            return Object.assign({}, state, { isMenusTableReady: action.payload })
        case ADD_EDIT_MENU_READY:
            return Object.assign({}, state, { isAddEditMenuReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case MENU_ID_FOR_ACTION:
            return Object.assign({}, state, {menuSelectedId:action.payload})

        case PREVIOUS_MENU_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_MENU_FILTER_SKU:
            return Object.assign({}, state, {previousFilterSku:action.payload})

        default:
        return state
    
    }

}

export function menuTableReady(data) {
    return {
        type: MENUS_TABLE_READY,
        payload: data
    }
}


export function addEditMenuReady(data) {
    return {
        type: ADD_EDIT_MENU_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function menuIdForAction(menuId){
    return{
        type:MENU_ID_FOR_ACTION,
        payload:menuId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_MENU_FILTER_CITY,
        payload:filterVal
    }
}

export function previousFilterSku(filterVal){
    return{
        type:PREVIOUS_MENU_FILTER_SKU,
        payload:filterVal
    }
}









// WEBPACK FOOTER //
// ./src/modules/Menus/redux/menus.js